import { BaseSearchParametersModel } from "../../models/base-search-parameters.model";

import { SearchFiltersModel } from "./search-filters.model";

export class SearchParametersModel extends BaseSearchParametersModel {
    public templateId?: string;
    public filters: SearchFiltersModel;
    public topLevelCategoryId: string;
    public topLevelCategoryIds: Array<string>;

    public categories: Array<string>;
    public startDate: string;
    public endDate: string;

    public postcode: string;
    public distance: string;
}
